module.exports = __webpack_public_path__ + "img/historyEmpty.f1fc523f.png";